import { useStore } from 'vuex'

export default {
    name: 'FeatureNavigationTeam',
    props: {
        teamId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const store = useStore()

        const componentToShow = function(type) {
            return {
                "deltagere": "holdetsDeltagere",
                "runderegistreringer": "holdetsRoundCounterOverlay",
                "donationer": "holdetsDonationer",
                "lysposer": "holdetsLys",
            }[type] ?? "holdetsDeltagere"
        }

        const openPageOverlay = function(type, e) {
            const componentName = componentToShow(type)
            
            store.commit('main/set_page_overlay_content_data', {
                teamId: props.teamId
            })
            
            store.dispatch('main/openPageOverlay', {
                overlayContent: componentName,
                returnTarget: e.currentTarget
            })
        }
        
        return {
            openPageOverlay
        }
    }
}
